class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.querySelector(".not-pu-section");
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.cookie = document.cookie.includes("hideNotificationPopup=true");
    this.isGoogleAdsVisitor = this.getGoogleAdsVisitStatus();

    if (this.hasSubscription || this.cookie || this.isGoogleAdsVisitor) return;

    setTimeout(() => {
      this.popup.classList.remove("hidden");
      this.popup.classList.add("wt-popup-fade-in");
    }, this.delay * 1000);

    this.closeBtn.addEventListener("click", (event) => {
      event.preventDefault();
      this.popup.classList.add("hidden");
      this.setCookie("hideNotificationPopup", "true", 7);
    });
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  getGoogleAdsVisitStatus() {
    const storageKey = "googleAdsVisit";

    try {
      if (window.sessionStorage.getItem(storageKey) === "true") return true;
    } catch (error) {
      // The current landing page can still be detected if storage is unavailable.
    }

    const params = new URLSearchParams(window.location.search);
    const hasGoogleAdsClickId = ["gclid", "wbraid", "gbraid"].some((param) => params.has(param));
    const source = params.get("utm_source")?.toLowerCase();
    const medium = params.get("utm_medium")?.toLowerCase();
    const hasGoogleAdsUtm =
      source === "google" && ["cpc", "ppc", "paidsearch", "display", "cpm", "cpa"].includes(medium);

    if (!hasGoogleAdsClickId && !hasGoogleAdsUtm) return false;

    try {
      window.sessionStorage.setItem(storageKey, "true");
    } catch (error) {
      // Nothing else is required: the popup remains hidden on this page.
    }

    return true;
  }
}

customElements.define("notification-popup", NotificationPopup);
